var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalCourses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2238_5438",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2238_5438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 22.5L29.9998 15.8333L19.9998 9.16667V22.5ZM9.49978 36.4583C8.58312 36.5972 7.75673 36.3819 7.02062 35.8125C6.28451 35.2431 5.86089 34.5 5.74978 33.5833L3.54145 15.375C3.43034 14.4583 3.65256 13.6389 4.20812 12.9167C4.76367 12.1944 5.49978 11.7778 6.41645 11.6667L8.33312 11.4167V25C8.33312 26.8333 8.98589 28.4028 10.2915 29.7083C11.597 31.0139 13.1664 31.6667 14.9998 31.6667H30.4998C30.3331 32.3333 29.9998 32.9097 29.4998 33.3958C28.9998 33.882 28.3887 34.1667 27.6665 34.25L9.49978 36.4583ZM14.9998 28.3333C14.0831 28.3333 13.2984 28.0069 12.6456 27.3542C11.9928 26.7014 11.6665 25.9167 11.6665 25V6.66667C11.6665 5.75 11.9928 4.96528 12.6456 4.3125C13.2984 3.65972 14.0831 3.33334 14.9998 3.33334H33.3331C34.2498 3.33334 35.0345 3.65972 35.6873 4.3125C36.3401 4.96528 36.6665 5.75 36.6665 6.66667V25C36.6665 25.9167 36.3401 26.7014 35.6873 27.3542C35.0345 28.0069 34.2498 28.3333 33.3331 28.3333H14.9998Z",
    fill: "#A435F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCourses);
export default __webpack_public_path__ + "static/media/TotalCourses.461cd7b10bdc28e10806b34aa8d4e6c0.svg";
export { ForwardRef as ReactComponent };